// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2pa-F","head":"ProcedureTableInfo_head__1BKbA"};